import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tabActiveType: 1,
      tradingRulesList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      types: 0, // 判断交易指南要展示的图片
      htmlImg: '',
      isShowVideo: true
    };
  },
  computed: {
    ...mapGetters([
      'isSignin'
    ])
  },
  created() {
    this.getTradingRulesList();
    this.types = this.$route.params.type;
  },
  watch: {
    $route () {
      this.getTradingRulesList();
      this.types = this.$route.params.type;

      // 交易制度未登录限制
      if(!this.isSignin && Number(this.types) === 2) {
        this.$router.push('/signin');
        return;
      }
    }
  },
  methods: {
    changeSkin,
    // 详情
    toDetailPage(id) {
      console.log(id);
      this.$router.push({
        path: '/notice-modular/system-update-detail',
        query: {
          id: id
        }
      });
    },
    changeTabIndex(item, index) {
      this.tabActiveType = index+1;
      this.htmlImg = item.content;
      if(item.newsId === 999999) {
        this.isShowVideo = true;
      } else {
        this.isShowVideo = false;
      }
    },
    getTradingRulesList(page) {
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const type = this.$route.params.type;
      const params = {type: 7, partId: type, pageNum: this.currentPage, pageSize: this.pageSize};
      Service.getNewsList(params).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tradingRulesList = res.data.list;
          this.tradingRulesList.forEach(item => {
            item.createTime = this.$options.filters['baseDate'](item.createTime);
          });
        }
      });
    }
  }
};
